module.exports = __webpack_public_path__ + "img/lets-get-out-of-here.fdd3953f.jpg";